// src/api/suiviNcs.api.ts — SCE Issues
// L'instantané du suivi des NC-S par la qualité (06/10) : bloc `suiviNcs` de
// la ligne `__global__` de SCE_UserPrefs, écrit par qui a accès au registre
// qualité, lu par tous. Règles : utils/suiviNcs.ts.

import { lireBlocGlobal, modifierBlocGlobal, reglagesConfigures } from './reglagesGlobaux.api'
import { blocSuiviMisAJour, lireBlocSuivi, type BlocSuiviNcs } from '@/utils/suiviNcs'
import type { LigneRegistre } from '@/utils/registreNcs'

const BLOC = 'suiviNcs'

export async function lireSuiviNcs(): Promise<BlocSuiviNcs | null> {
  if (!reglagesConfigures()) return null
  return lireBlocSuivi(await lireBlocGlobal(BLOC))
}

/**
 * Range dans l'instantané l'état des NC-S `numeros` lu dans le registre.
 * N'écrit que si quelque chose a changé ; relu avant d'écrire (un collègue a
 * pu le mettre à jour entre-temps).
 * @returns le bloc écrit, ou null si rien n'a changé.
 */
export async function enregistrerSuiviNcs(
  registre: readonly LigneRegistre[],
  numeros: ReadonlySet<string>,
  maintenant: Date,
): Promise<BlocSuiviNcs | null> {
  if (!reglagesConfigures() || numeros.size === 0) return null
  if (!blocSuiviMisAJour(await lireSuiviNcs(), registre, numeros, maintenant)) return null
  let ecrit: BlocSuiviNcs | null = null
  await modifierBlocGlobal(BLOC, (actuel) => {
    const avant = lireBlocSuivi(actuel)
    ecrit = blocSuiviMisAJour(avant, registre, numeros, maintenant) ?? avant
    return ecrit
  })
  return ecrit
}
